import { useOutletContext } from "react-router-dom";
import CalForm from "./CalForm";
import { IntegrationShell } from "../common/Shell";

function CalIntegration() {
  const { projectId, isViewOnly } = useOutletContext<{ projectId: string; isViewOnly: boolean }>();

  return (
    <IntegrationShell>
      <CalForm workspaceId={projectId} isViewOnly={isViewOnly}/>
    </IntegrationShell>
  );
}

export default CalIntegration;
